let manualSentRow = null;
let manualDeliveredRow = null;
let manualDeliveredUrl = "";
let manualDeliveredPreviewObjectUrl = null;
let bulkManualSentOrderIds = [];

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
}

function hasManualSentUi() {
  return document.getElementById("manualSentModal") || document.getElementById("bulkManualSentModal") || document.getElementById("manualDeliveredModal");
}

function orderCountLabel(count) {
  return `${count} pedido${count === 1 ? "" : "s"}`;
}

function setText(id, value) {
  const element = document.getElementById(id);
  if (element) element.textContent = value || "-";
}

function nowLocalDateValue() {
  const now = new Date();
  const tzAdjusted = new Date(now.getTime() - (now.getTimezoneOffset() * 60000));
  return tzAdjusted.toISOString().slice(0, 10);
}

function setEvidenceFileName(fileName) {
  const fileNameElement = document.getElementById("manualDeliveredEvidenceFileName");
  const uploadTrigger = document.getElementById("manualDeliveredUploadTrigger");
  if (!fileNameElement || !uploadTrigger) return;

  if (fileName) {
    fileNameElement.textContent = `Arquivo: ${fileName}`;
    fileNameElement.classList.remove("d-none");
    uploadTrigger.classList.add("has-file");
  } else {
    fileNameElement.textContent = "";
    fileNameElement.classList.add("d-none");
    uploadTrigger.classList.remove("has-file");
  }
}

function clearEvidencePreview() {
  const previewWrap = document.getElementById("manualDeliveredEvidencePreviewWrap");
  const previewImage = document.getElementById("manualDeliveredEvidencePreview");

  if (manualDeliveredPreviewObjectUrl) {
    URL.revokeObjectURL(manualDeliveredPreviewObjectUrl);
    manualDeliveredPreviewObjectUrl = null;
  }

  if (previewImage) previewImage.removeAttribute("src");
  previewWrap?.classList.add("d-none");
}

function setEvidencePreview(file) {
  const previewWrap = document.getElementById("manualDeliveredEvidencePreviewWrap");
  const previewImage = document.getElementById("manualDeliveredEvidencePreview");
  if (!previewWrap || !previewImage) return;

  if (!file || !file.type || !file.type.startsWith("image/")) {
    clearEvidencePreview();
    return;
  }

  if (manualDeliveredPreviewObjectUrl) {
    URL.revokeObjectURL(manualDeliveredPreviewObjectUrl);
  }

  manualDeliveredPreviewObjectUrl = URL.createObjectURL(file);
  previewImage.src = manualDeliveredPreviewObjectUrl;
  previewWrap.classList.remove("d-none");
}

function selectedBulkOrders() {
  return Array.from(document.querySelectorAll(".row-check:checked")).map((checkbox) => {
    const row = checkbox.closest("tr");

    return {
      id: checkbox.value,
      displayId: row?.dataset.orderDisplayId || checkbox.value,
      customerName: row?.dataset.customerName || "-",
      location: row?.dataset.orderLocation || "-"
    };
  });
}

function renderSelectedOrders(orders) {
  const list = document.getElementById("bulkManualSentSelectedOrdersList");
  if (!list) return;

  list.replaceChildren(...orders.map((order) => {
    const item = document.createElement("div");
    item.className = "rounded border bg-white px-3 py-2 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-1";

    const title = document.createElement("div");
    title.className = "fw-semibold";
    title.textContent = order.displayId;

    const meta = document.createElement("div");
    meta.className = "text-muted";
    meta.textContent = `${order.customerName} - ${order.location}`;

    item.append(title, meta);
    return item;
  }));
}

function setupManualSentModal(trigger) {
  const confirmLink = document.getElementById("confirmManualSentLink");
  if (!trigger || !confirmLink) return;

  manualSentRow = trigger.closest("tr");
  confirmLink.href = trigger.dataset.markStatusUrl || "#";

  setText("manualSentOrderDisplayId", trigger.dataset.orderId);
  setText("manualSentCustomerName", trigger.dataset.customerName);
  setText("manualSentCurrentStatus", trigger.dataset.currentStatus);
  setText("manualLocation", [trigger.dataset.orderCity, trigger.dataset.orderState].filter(Boolean).join("/"));
}

function setupBulkManualSentModal(event) {
  const orders = selectedBulkOrders();

  if (orders.length === 0) {
    event.preventDefault();
    return;
  }

  bulkManualSentOrderIds = orders.map((order) => order.id);
  renderSelectedOrders(orders);

  const countLabel = orderCountLabel(orders.length);
  document.getElementById("bulkManualSentDescription").innerHTML = `Você está marcando <strong>${countLabel}</strong> como <strong>Enviado</strong> manualmente.`;
  setText("bulkManualSentSelectedCount", countLabel);
  setText("bulkManualSentReadyCount", countLabel);
  setText("bulkManualSentSelectedListCount", orders.length);
}

function setupManualDeliveredModal(trigger) {
  const confirmButton = document.getElementById("confirmManualDeliveredButton");
  if (!confirmButton) return;

  if (trigger) {
    manualDeliveredRow = trigger.closest("tr");
    manualDeliveredUrl = trigger.dataset.markStatusUrl || "";
    confirmButton.dataset.markStatusUrl = manualDeliveredUrl;

    setText("manualDeliveredOrderDisplayId", trigger.dataset.orderId);
    setText("manualDeliveredCustomerName", trigger.dataset.customerName);
    setText("manualDeliveredLocation", [trigger.dataset.orderCity, trigger.dataset.orderState].filter(Boolean).join("/"));

    const recipientInput = document.getElementById("manualDeliveredRecipientName");
    if (recipientInput) recipientInput.value = trigger.dataset.recipientName || "";

    const recipientDocumentInput = document.getElementById("manualDeliveredRecipientDocument");
    if (recipientDocumentInput) recipientDocumentInput.value = trigger.dataset.recipientDocument || "";
  }

  const deliveredAtInput = document.getElementById("manualDeliveredReceivedAt");
  if (deliveredAtInput) deliveredAtInput.value = nowLocalDateValue();

  const evidenceInput = document.getElementById("manualDeliveredEvidence");
  if (evidenceInput) evidenceInput.value = "";
  setEvidenceFileName("");
  clearEvidencePreview();

  confirmButton.onclick = async (event) => {
    event.preventDefault();
    try {
      await updateDeliveredStatus(confirmButton);
    } catch (err) {
      console.error(err);
      alert("Erro ao tentar atualizar o status.");
    }
  };
}

document.addEventListener("show.bs.modal", (event) => {
  if (event.target.id === "manualSentModal") {
    setupManualSentModal(event.relatedTarget);
  }

  if (event.target.id === "bulkManualSentModal") {
    setupBulkManualSentModal(event);
  }

  if (event.target.id === "manualDeliveredModal") {
    setupManualDeliveredModal(event.relatedTarget);
  }
});

document.addEventListener("click", async (event) => {
  if (!hasManualSentUi()) return;

  const clickTarget = event.target instanceof Element ? event.target : event.target?.parentElement;
  if (!clickTarget) return;

  const statusLink = clickTarget.closest("a.mark-status-link");
  const bulkButton = clickTarget.closest("#confirmBulkManualSentButton");

  try {
    if (statusLink) {
      event.preventDefault();
      await updateSingleStatus(statusLink);
    }

    if (bulkButton) {
      event.preventDefault();
      await updateBulkStatus(bulkButton);
    }
  } catch (err) {
    console.error(err);
    alert("Erro ao tentar atualizar o status.");
  }
});

document.addEventListener("change", (event) => {
  if (event.target.id !== "manualDeliveredEvidence") return;
  const file = event.target.files?.[0];
  setEvidenceFileName(file?.name || "");
  setEvidencePreview(file);
});

document.addEventListener("input", (event) => {
  if (event.target.id !== "manualDeliveredRecipientDocument") return;
  event.target.value = event.target.value.replace(/\D/g, "");
});

async function updateSingleStatus(link) {
  const token = csrfToken();
  if (!token) return alert("CSRF token ausente");

  const row = link.id === "confirmManualSentLink" ? manualSentRow : link.closest("tr");
  const res = await fetch(link.href, {
    method: "PATCH",
    headers: {
      "X-CSRF-Token": token,
      "Accept": "application/json"
    },
    credentials: "same-origin"
  });
  const data = await res.json();

  if (!res.ok || !data.ok) return alert(data.message || "Não foi possível atualizar o pedido.");

  const statusTd = row?.querySelector(".js-order-status-cell");
  if (statusTd) statusTd.textContent = link.dataset.statusLabel || data.status;

  if (link.id === "confirmManualSentLink") {
    window.bootstrap?.Modal.getInstance(document.getElementById("manualSentModal"))?.hide();
  }
}

async function updateBulkStatus(button) {
  const token = csrfToken();
  if (!token) return alert("CSRF token ausente");
  if (bulkManualSentOrderIds.length === 0) return alert("Selecione ao menos 1 pedido.");

  const formData = new FormData();
  formData.append("status", button.dataset.status || "SENT");
  bulkManualSentOrderIds.forEach((orderId) => formData.append("order_ids[]", orderId));

  button.disabled = true;

  try {
    const res = await fetch(button.dataset.bulkMarkStatusUrl, {
      method: "POST",
      headers: { "X-CSRF-Token": token },
      body: formData,
      credentials: "same-origin"
    });

    if (!res.ok) return alert("Não foi possível atualizar os pedidos.");

    window.bootstrap?.Modal.getInstance(document.getElementById("bulkManualSentModal"))?.hide();
    window.location.reload();
  } catch (err) {
    console.error(err);
    alert("Erro ao tentar atualizar os pedidos.");
  } finally {
    button.disabled = false;
  }
}

async function updateDeliveredStatus(button) {
  const token = csrfToken();
  if (!token) return alert("CSRF token ausente");

  const url = button.dataset.markStatusUrl || manualDeliveredUrl;
  if (!url) return alert("Não foi possível identificar o pedido.");

  const recipientName = document.getElementById("manualDeliveredRecipientName")?.value?.trim();
  const recipientDocument = document.getElementById("manualDeliveredRecipientDocument")?.value?.replace(/\D/g, "");
  const deliveredAt = document.getElementById("manualDeliveredReceivedAt")?.value;
  const evidenceFile = document.getElementById("manualDeliveredEvidence")?.files?.[0];

  if (!recipientName) return alert("Informe o nome do recebedor.");
  if (!recipientDocument) return alert("Informe o documento do recebedor.");
  if (!deliveredAt) return alert("Informe a data de recebimento.");
  if (!evidenceFile) return alert("Anexe a imagem de evidência.");
  if (!evidenceFile.type || !evidenceFile.type.startsWith("image/")) return alert("A evidência deve ser uma imagem.");
  if (evidenceFile.size > (10 * 1024 * 1024)) return alert("A imagem de evidência deve ter no máximo 10MB.");

  const formData = new FormData();
  formData.append("recipient_name", recipientName);
  formData.append("recipient_document_number", recipientDocument);
  formData.append("delivered_at", deliveredAt);
  formData.append("evidence", evidenceFile);

  button.disabled = true;

  try {
    const res = await fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: formData,
      credentials: "same-origin"
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.ok) return alert(data.message || "Não foi possível atualizar o pedido.");

    const statusTd = manualDeliveredRow?.querySelector(".js-order-status-cell");
    if (statusTd) statusTd.textContent = button.dataset.statusLabel || data.status;

    window.bootstrap?.Modal.getInstance(document.getElementById("manualDeliveredModal"))?.hide();
  } finally {
    button.disabled = false;
  }
}
